import { render } from "./DepositUDT.vue?vue&type=template&id=52cd2a44&scoped=true"
import script from "./DepositUDT.vue?vue&type=script&lang=js"
export * from "./DepositUDT.vue?vue&type=script&lang=js"

import "./DepositUDT.vue?vue&type=style&index=0&id=52cd2a44&lang=css"
import "./DepositUDT.vue?vue&type=style&index=1&id=52cd2a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cd2a44"]])

export default __exports__